exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-wp-page-tsx": () => import("./../../../src/templates/wp-page.tsx" /* webpackChunkName: "component---src-templates-wp-page-tsx" */),
  "component---src-templates-wp-post-tsx": () => import("./../../../src/templates/wp-post.tsx" /* webpackChunkName: "component---src-templates-wp-post-tsx" */),
  "component---src-templates-wp-preview-tsx": () => import("./../../../src/templates/wp-preview.tsx" /* webpackChunkName: "component---src-templates-wp-preview-tsx" */)
}

